import { api } from './client.ts';
import type { VisitInstructions } from '../../shared/visit-instructions.ts';
import type { Company, SessionUser } from '../../shared/types/index.ts';

const path = (id: string) => `/schedule/appointments/${id}/instructions`;
export const visitInstructionsApi = {
  read: (id: string) => api.get<VisitInstructions>(path(id)),
  add: (id: string, body: { requestKey: string; text: string; messageId?: string }) =>
    api.post<{ id: string }>(path(id), body),
  decide: (id: string, instructionId: string, body: { decision: 'approve'; text: string } | { decision: 'decline' }) =>
    api.post(`${path(id)}/${instructionId}/decision`, body),
  acknowledge: (id: string, version: number) => api.post(`${path(id)}/ack`, { version }),
};
export const instructionsKey = (
  id: string,
  user: SessionUser | null,
  company: Company | null,
  locationId?: string,
  impersonatedBy?: string | null,
) => [
  'visit-instructions',
  id,
  user?.id,
  company?.id,
  locationId,
  user?.role,
  [...(user?.permissions ?? [])].sort().join(','),
  company?.effectivePlan,
  [...(company?.planFeatures ?? [])].sort().join(','),
  company?.accessLocked,
  impersonatedBy,
];
